import { gql } from 'graphql-request';

export default gql`
  query devices(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    devices(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      devices {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt

        Owner {
          id
          doc
          hasPhoto
          extra
        }
      }
    }
  }
`;
